const getBlogType = (type: string): string => {
  switch (type) {
    case 'blog_post':
      return '/blog';
    case 'guides_post':
      return '/guides';
    case 'case_studies_post':
      return '/case-studies';
    default:
      return '/blog';
  }
};

export default getBlogType;
